/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteRequestExchange
 */
export interface QuoteRequestExchange {
  /**
   *
   * @type {string}
   * @memberof QuoteRequestExchange
   */
  exchangeId: string;
  /**
   *
   * @type {string}
   * @memberof QuoteRequestExchange
   */
  requestedAt?: string;
  /**
   * What we asked the carrier's system at quote time.
   * @type {string}
   * @memberof QuoteRequestExchange
   */
  request?: string;
  /**
   * What it answered. This is the carrier's own data and settles most
   * "we never quoted that" disputes outright.
   *
   * @type {string}
   * @memberof QuoteRequestExchange
   */
  response?: string;
}

/**
 * Check if a given object implements the QuoteRequestExchange interface.
 */
export function instanceOfQuoteRequestExchange(
  value: object,
): value is QuoteRequestExchange {
  if (!("exchangeId" in value) || value["exchangeId"] === undefined)
    return false;
  return true;
}

export function QuoteRequestExchangeFromJSON(json: any): QuoteRequestExchange {
  return QuoteRequestExchangeFromJSONTyped(json, false);
}

export function QuoteRequestExchangeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteRequestExchange {
  if (json == null) {
    return json;
  }
  return {
    exchangeId: json["exchangeId"],
    requestedAt: json["requestedAt"] == null ? undefined : json["requestedAt"],
    request: json["request"] == null ? undefined : json["request"],
    response: json["response"] == null ? undefined : json["response"],
  };
}

export function QuoteRequestExchangeToJSON(json: any): QuoteRequestExchange {
  return QuoteRequestExchangeToJSONTyped(json, false);
}

export function QuoteRequestExchangeToJSONTyped(
  value?: QuoteRequestExchange | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    exchangeId: value["exchangeId"],
    requestedAt: value["requestedAt"],
    request: value["request"],
    response: value["response"],
  };
}
